import { takeLatest } from 'redux-saga/effects';

export const actionTypes = {
	UpdateFilter: '[Dashboard] UpdateFilter',
	UpdateLoading: '[Dashboard] UpdateLoading',
	UpdateData: '[Dashboard] UpdateData',
	UpdateSales: '[Dashboard] UpdateSales',
	UpdateSessionsCount: '[Dashboard] UpdateSessionsCount',
	ResetState: '[Dashboard] ResetState',
	UpdateActive: '[Dashboard] UpdateActive',
};

export const initialState = {
	filter: {},
	sales: {},
	session: {},
	users: {},
	posts: {},
	interactions: {},
	wishlist: {},
	totals: null,
	liveNow: [],
	statistics: [],
	monthlySessionsCount: 0,
	loading: false,
	active: 'Users',
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.UpdateFilter:
			return {
				...state,
				filter: action.filter,
				loading: false,
			};
		case actionTypes.UpdateLoading:
			return {
				...state,
				loading: action.payload,
			};
		case actionTypes.UpdateData:
			return {
				...state,
				statistics: action.payload.statistics,
				totals: { ...state.totals, ...action.payload.metricsTotals },
				loading: false,
			};
		case actionTypes.UpdateSessionsCount:
			return {
				...state,
				monthlySessionsCount: action.payload
			};
		case actionTypes.UpdateSales:
			return {
				...state,
				sales: action.payload.sales,
				loading: false,
			};
		case actionTypes.UpdateActive:
			return {
				...state,
				active: action.payload,
			};
		case actionTypes.ResetState:
			return {
				...state,
				totals: null,
				statistics: [],
			};
		default:
			return state;
	}
};

export const actions = {
	updateFilter: (payload) => ({ type: actionTypes.UpdateFilter, payload }),
	updateLoading: (payload) => ({ type: actionTypes.UpdateLoading, payload }),
	updateData: (payload) => ({ type: actionTypes.UpdateData, payload }),
	updateSales: (payload) => ({ type: actionTypes.UpdateSales, payload }),
	updateActive: (payload) => ({ type: actionTypes.UpdateActive, payload }),
	updateSessionsCount: (payload) => ({ type: actionTypes.UpdateSessionsCount, payload }),
	resetState: (payload) => ({ type: actionTypes.ResetState, payload }),
};

export function* saga() {
	yield takeLatest('[Global] UpdateFilter', function* updateData(action) { });
}